// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
/* 路由 */
import router from './router'

/* axios */
/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
/* 尾部组件 */
import Footer from './components/Footer'
/* 回到顶部 */
import GoTop from './components/GoTop'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Pagination from './components/Pagination'
import store from './store'
import VueLazyload from 'vue-lazyload';


Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://nf-agriculture.itms.site/upload/stipulate_annex/185e/147c/65f28018bfdd6ea7cfb5ca4.webp', // 加载失败时显示的图片
  loading: 'https://nf-agriculture.itms.site/upload/stipulate_annex/185e/147c/65f28018bfdd6ea7cfb5ca4.webp', // 加载中的占位图
  attempt: 1,
});


Vue.use(ElementUI);
Vue.component(Header.name, Header)

Vue.component('Pagination', Pagination)
Vue.component(Footer.name, Footer)

Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next();
});


new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js